/**
 * @file 密码相关
 *
 * @todo 补充单元测试
 */
/**
 * 密码强度
 */
export var PasswordStrengthEnum;
(function (PasswordStrengthEnum) {
    PasswordStrengthEnum["Weak"] = "weak";
    PasswordStrengthEnum["Normal"] = "normal";
    PasswordStrengthEnum["Strong"] = "strong";
})(PasswordStrengthEnum || (PasswordStrengthEnum = {}));
/**
 * 根据各权重值计算密码强度
 * PRD: https://www.yuque.com/preview/yuque/0/2020/rp/581946/1599734639863-5ef078e3-0aa5-4ff9-8a4a-0669104c8f08.rp?from=https%3A%2F%2Fwww.yuque.com%2Fkovru3%2Fhtekrb%2Fvbsldx
 *
 * @category Password
 * @param pwd - 密码
 * @returns 强度
 */
export const getPasswordStrength = (pwd) => {
    if (!pwd)
        return null;
    let weight = 0;
    // 16 - 30，权重 10
    if (pwd.length > 15) {
        weight += 10;
    }
    // 7 - 15，权重 6
    if (pwd.length > 6 && pwd.length < 16) {
        weight += 6;
    }
    // === 6，权重 1
    if (pwd.length === 6) {
        weight += 1;
    }
    // 包含一种，权重 + 2
    const has1 = /[a-z]/.test(pwd);
    const has2 = /[A-Z]/.test(pwd);
    const has3 = /[0-9]/.test(pwd);
    const has4 = /[~!@$^*()-._<>]/.test(pwd);
    const charFlag = [has1, has2, has3, has4].filter(Boolean);
    weight += 2 * charFlag.length;
    // 后一个字符和前一个字符一样，权重 - 1
    const pwdCharList = pwd.split('');
    for (let i = 1; i < pwdCharList.length; i += 1) {
        if (pwdCharList[i] === pwdCharList[i - 1]) {
            weight -= 1;
        }
    }
    if (weight < 9)
        return PasswordStrengthEnum.Weak;
    if (weight > 12)
        return PasswordStrengthEnum.Strong;
    return PasswordStrengthEnum.Normal;
};
/**
 * 生成易读的随机密码
 *
 * @category Password
 * @param length - 密码长度
 * @returns 密码
 */
export function generateRandomSimplePassword(length = 8) {
    const usedStr = 'abcdefghjklmnpqrstuvwxyz23456789';
    let len = length;
    let result = '';
    while (len) {
        len -= 1;
        const value = usedStr[Math.floor(Math.random() * usedStr.length)];
        result += value;
    }
    return result;
}
//# sourceMappingURL=data:application/json;base64,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